export function canvasContext(
  canvas?: HTMLCanvasElement | null,
): readonly [HTMLCanvasElement | null, CanvasRenderingContext2D | null] {
  const nextCanvas = canvas instanceof HTMLCanvasElement ? canvas : null;
  const context = nextCanvas ? nextCanvas.getContext("2d") : null;

  return [nextCanvas, context] as const;
}
